import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

@Injectable({ providedIn: 'root' })
export class CurrentState<T> {
  public snapshot: T;

  constructor(store: Store<T>) {
    store.subscribe(current => this.snapshot = current);
  }
}
